@if (source && source.columnFilters && source.operatorFilters) {
  <ng-container
    [ngTemplateOutlet]="favoriteFilter"
    [ngTemplateOutletContext]="{
      columnFilters: source.columnFilters,
      operatorFilters: source.operatorFilters,
      $implicit: selected,
    }" />
} @else {
  <ng-container
    [ngTemplateOutlet]="favoriteFilter"
    [ngTemplateOutletContext]="{ columnFilters: { items: [] }, operatorFilters: { items: [] }, data: selected }" />
}

<ng-template #favoriteFilter let-columnFilters="columnFilters" let-operatorFilters="operatorFilters" let-selected>
  <div
    id="group-filter-panel"
    class="group-list ui-overlaypanel {{ gridView?.isTree ? 'hasTreeView' : '' }} {{ isMobile ? 'mobile' : '' }}">
    <!-- FILTERS -->
    @if (selected?.filters.length > 0) {
      <ul #filtersContainer cdkDropList data-uf="filters" (cdkDropListDropped)="moveItem($event, 'filters')">
        @for (filter of selected.filters; track filter) {
          <div cdkDrag data-cy="universal-filter-line" [attr.data-cy-index]="$index">
            <div *cdkDragPreview class="ui-row-drag-preview">
              {{ 'universalFilter.filterPreview' | translate }}{{ filter.column.displayValue || '[ColumnName]' }}
              {{ filter.operator.displayValue || '[Operator]' }}
              {{ filter.filter || '[Filter]' }}
              {{
                filter.filterTo !== undefined && filter.filterTo !== null && filter.filterTo !== ''
                  ? ' - ' + filter.filterTo
                  : ''
              }}
            </div>
            <div *cdkDragPlaceholder class="ui-row-drag-placeholder"></div>
            <li class="ui-row" [attr.data-cy-row]="filter.column.id">
              <span cdkDragHandle class="icon-grab" style="font-size: 17px; cursor: move"></span>
              <div class="filtres">
                <div
                  data-cy="universal-filter-column-autocomplete"
                  class="lev-1 filter-field {{ filter?.column?.id === -1 ? 'valueEmpty' : '' }}">
                  <iu-autocomplete-ui
                    [data]="
                      columnFilters
                        | universalFilterColFilterType
                          : 0
                          : $index
                          : (gridView?.viewType === ViewType.CALENDAR
                              ? CompiereDataGridFilterType.DATE
                              : CompiereDataGridFilterType.NONE)
                        | autocompleteSuggestionsFilter: usedFilterColumnNames : filter.column.id
                    "
                    [fieldValue]="filter.column"
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                    [isStandalone]="true"
                    (fieldValueModified)="setColumnFilter($any($event), $index)" />
                </div>

                <div
                  data-cy="universal-filter-operator-autocomplete"
                  class="lev-2 filter-field {{ filter?.column?.id === -1 ? 'valueEmpty' : '' }}">
                  <iu-autocomplete-ui
                    [data]="operatorFilters | operatorFilter: filter?.column?.columnInfo?.filterType"
                    [fieldValue]="filter.operator"
                    [isInUniversalFilter]="true"
                    [isInsideOverflow]="true"
                    [isStandalone]="true"
                    (fieldValueModified)="setOperatorFilter($any($event), $index)" />
                </div>

                <div
                  data-cy="universal-filter-value"
                  class="lev-3 filter-field {{ filter?.operator?.operator?.isRange ? 'isRange' : '' }}">
                  <ng-template #vcrFilter />
                </div>
                <div
                  data-cy="universal-filter-value-to"
                  class="lev-4 filter-field {{ filter?.operator?.operator?.isRange ? 'isRange' : '' }}">
                  @if (filter?.operator?.operator?.isRange) {
                    @switch (filter?.column?.columnInfo?.filterType) {
                      @case ('text') {
                        <iu-input-text-ui
                          [fieldValue]="filter.filterTo"
                          [isInUniversalFilter]="true"
                          [isStandalone]="true"
                          (fieldValueModified)="setFilterTo($event, $index)" />
                      }
                      @case ('number') {
                        <iu-input-number-ui
                          [fieldValue]="filter.filterTo"
                          [isInUniversalFilter]="true"
                          [isStandalone]="true"
                          (fieldValueModified)="setFilterTo($event, $index)" />
                      }
                      @case ('date') {
                        <iu-calendar-ui
                          [calendarConfig]="filter.configsTo?.calendarConfig || { todayMode: false }"
                          [data]="{
                            needTime: filter.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16,
                          }"
                          [fieldValue]="
                            filter.filterTo | toDate: filter.column.columnInfo.fieldEntity.field.AD_Reference_ID === 16
                          "
                          [hasTodayBtn]="true"
                          [isInUniversalFilter]="true"
                          [isStandalone]="true"
                          (calendarConfigChange)="onCalendarConfigChange($event, $index, true)"
                          (fieldValueModified)="setFilterTo($event, $index)" />
                      }
                      @case ('time') {
                        <iu-input-time-ui
                          [calendarConfig]="filter.configsTo?.calendarConfig || { todayMode: false }"
                          [fieldValue]="filter.filterTo | toDate: true"
                          [isInUniversalFilter]="true"
                          [isStandalone]="true"
                          (calendarConfigChange)="onCalendarConfigChange($event, $index, true)"
                          (fieldValueModified)="setFilterTo($event, $index)" />
                      }
                    }
                  }
                </div>
              </div>
              <div class="delete" data-cy="universal-filter-remove-filter">
                <button
                  class="hover"
                  icon="icon-delete"
                  pButton
                  tooltipPosition="top"
                  type="button"
                  [hideDelay]="250"
                  [life]="3000"
                  pTooltip="{{ 'generic.delete' | translate }}"
                  [showDelay]="250"
                  (click)="removeFilter($index, $event)"></button>
              </div>
            </li>
          </div>
        }
      </ul>
    }
    <ul class="buttonAdd">
      <li class="ui-row">
        <div class="p-col-12">
          <button
            class="button p-button-secondary"
            data-cy="universal-filter-add-filter-one"
            icon="icon-add"
            id="addrow"
            pButton
            style="cursor: pointer"
            label="{{ 'universalFilter.addFilter' | translate }}"
            (click)="addFilter($event)"></button>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
